import React from 'react'
import styled from 'styled-components';

export default styled(({className, style, onClick, text, iconPath, disabled, labelStyle}) => <button disabled={disabled} className={className} style={style} onClick={onClick}>
    <span style={labelStyle}>{text}</span>
    <img alt="" src={iconPath} />
</button>)`
border: none;
width: 384px;
height: 70px;
background-color: #363b41;
text-align: left; 
display: flex;
align-items: center;
padding-left: 40px;
padding-right: 40px;
cursor: pointer;
margin-bottom: 0;

&:disabled{
    opacity: 0.4;
}

span{
    width: 125px;
    height: 18px;
    font-family: Lato;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #edeeee;
}
img{
    margin-left: auto;
}
`;